import { render, staticRenderFns } from "./ComprobantPay.vue?vue&type=template&id=52dddd75&scoped=true&"
import script from "./ComprobantPay.vue?vue&type=script&lang=js&"
export * from "./ComprobantPay.vue?vue&type=script&lang=js&"
import style0 from "./ComprobantPay.vue?vue&type=style&index=0&id=52dddd75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dddd75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VPagination,VRow,VSimpleTable,VSpacer,VTextField})
